import { z } from 'zod';
export const uuid = z.string().uuid();
export const paginationQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(25),
    sort: z.string().optional(),
    order: z.enum(['asc', 'desc']).default('asc'),
    q: z.string().trim().max(200).optional(),
});
export function paginated(item) {
    return z.object({
        data: z.array(item),
        page: z.number().int(),
        pageSize: z.number().int(),
        total: z.number().int(),
    });
}
/** RFC-7807-ish problem detail shape returned by the API on errors. */
export const problemDetail = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    code: z.string().optional(),
    errors: z.record(z.array(z.string())).optional(),
    requestId: z.string().optional(),
});
//# sourceMappingURL=common.js.map